import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-orrecord',
  templateUrl: './orrecord.component.html',
  styleUrls: ['./orrecord.component.css']
})
export class OrrecordComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
